// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"565":"7110fae5","787":"d02b5c29"}[chunkId] + ".chunk.js";
};